import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../app.configs';
import { AuthService } from './auth.service';
import {
  SettlementWallet,
  FlushSettlementWalletPayload,
  FlushSettlementWalletResponse,
} from '../models/settlement-wallet.model';

@Injectable({
  providedIn: 'root',
})
export class SettlementWalletService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  /**
   * Fetch all settlement wallets with current balances for a user.
   */
  getSettlementWallets(userUuid: string): Observable<SettlementWallet[]> {
    const headers = this.authService.getHeaders();
    return this.http.get<SettlementWallet[]>(
      Config.toApiUrl(`dashboard/users/${userUuid}/settlement-wallets/`),
      {
        headers,
        withCredentials: true,
      },
    );
  }

  /**
   * Flush funds in the given currency from a specific settlement wallet to the
   * user's main Privy wallet.
   * When a transaction UUID is given, the backend first collects any fee still
   * owed on that transaction, then flushes the remainder.
   */
  flushSettlementWallet(
    userUuid: string,
    walletUuid: string,
    amount: number,
    currency: string,
    transactionUuid?: string | null,
  ): Observable<FlushSettlementWalletResponse> {
    const headers = this.authService.getHeaders();
    const payload: FlushSettlementWalletPayload = { amount, currency };
    if (transactionUuid) {
      payload.transaction_uuid = transactionUuid;
    }
    return this.http.post<FlushSettlementWalletResponse>(
      Config.toApiUrl(
        `dashboard/users/${userUuid}/settlement-wallets/${walletUuid}/flush/`,
      ),
      payload,
      {
        headers,
        withCredentials: true,
      },
    );
  }
}
